import React from "react";
import {
  Container,
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";

const features = [
  {
    icon: "💰",
    title: "Better Prices",
    text: "A single buyer has limited bargaining power. A larger group can negotiate significantly better prices and value-added benefits.",
  },
  {
    icon: "📊",
    title: "Compare Multiple Sellers",
    text: "Receive and compare quotations, offers, product features, warranties, service quality, financing options, delivery timelines, and other benefits from multiple sellers or service providers before making a decision.",
  },
  {
    icon: "🤝",
    title: "Negotiate Together",
    text: "Any group member can approach sellers or service providers and share the offers received. Our PriceWorth coordinator also negotiates on behalf of the group to obtain the best possible deals.",
  },
  {
    icon: "👨‍💼",
    title: "Dedicated PriceWorth Coordinator",
    text: "Our coordinator assists throughout the buying process by collecting offers, comparing proposals, answering questions, and helping the group negotiate better pricing and terms.",
  },
  {
    icon: "💬",
    title: "Private Group Chat",
    text: "Discuss products, offers, reviews, and experiences with other group members directly on this page without revealing your phone number or email address.",
  },
  {
    icon: "📱",
    title: "Optional WhatsApp Group",
    text: "Members who are comfortable sharing their contact details may join an optional WhatsApp group for faster discussions.",
  },
];

function ProductInfo() {
  return (
    <Container className="py-5" style={{  }}>
      <div className="text-center mb-5">
        <h2 className="fw-bold mb-3">Why Join This Group?</h2>
        <p
          className="text-muted mx-auto"
          style={{ maxWidth: "720px", fontSize: "1.05rem" }}
        >
         Get more value with every purchase. Join a group to compare products, enjoy exclusive 
         bulk discounts, secure better offers together, and receive expert assistance from the PriceWorth team.
        </p>
      </div>

      <Row className="g-4">
        {features.map((item, index) => (
          <Col lg={6} md={6} sm={12} key={index}>
            <Card className="h-100 border-0 shadow-sm rounded-4">
              <CardBody className="p-4">
                <div className="d-flex align-items-start">
                  <div
                    className="me-4 d-flex justify-content-center align-items-center rounded-circle bg-light"
                    style={{
                      width: "60px",
                      height: "60px",
                      fontSize: "1.8rem",
                      flexShrink: 0,
                    }}
                  >
                    {item.icon}
                  </div>

                  <div>
                    <h5 className="fw-bold mb-2">{item.title}</h5>

                    <p
                      className="text-muted mb-0"
                      style={{ lineHeight: "1.7" }}
                    >
                      {item.text}
                    </p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default ProductInfo;